import React from 'react';

import * as analytics from 'analytics/Analytics';
import {REQUESTS_V2_ANALYTICS_ACTIONS} from 'constants/analytics-products/RequestsV2AnalyticsConstants';
import {ActionMethod, ActionOrigin} from 'constants/AnalyticsConstants';
import {MinimalStorableSummaryWithSchemaId} from 'constants/SampleConstants';
import {BioentitySummary} from 'graphql-client/declarative-translations/external/RESTTypes';
import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import runModal from 'ui-library/runModal';

import CreateRequestV2SubmissionModal from '../modals/CreateRequestV2SubmissionModal';

interface CreateRequestV2SubmissionShortcutButtonProps {
  disabled: boolean;
  items: Array<BioentitySummary> | Array<MinimalStorableSummaryWithSchemaId>;
  actionOrigin: ActionOrigin;
  buttonStyle?: ButtonStyle;
}

export function trackCreateRequestV2SubmissionShortcutOpened(actionOrigin: ActionOrigin): void {
  analytics.trackEvent(REQUESTS_V2_ANALYTICS_ACTIONS.CLICKED_REQUESTS_V2_CREATE_SHORTCUT, {
    action_origin: actionOrigin,
    action_method: ActionMethod.BUTTON_CLICK,
  });
}

export default function CreateRequestV2SubmissionShortcutButton(
  props: CreateRequestV2SubmissionShortcutButtonProps
): JSX.Element {
  return (
    <Tooltip title="Create request">
      <Button
        buttonStyle={props.buttonStyle ?? ButtonStyle.TERTIARY_WHITE}
        size={ButtonSize.SMALL}
        icon="request_v2_submission"
        disabled={props.disabled}
        onClick={() => {
          runModal(CreateRequestV2SubmissionModal, {
            actionOrigin: props.actionOrigin,
            requestSeedData: {
              items: props.items,
            },
          });
          trackCreateRequestV2SubmissionShortcutOpened(props.actionOrigin);
        }}
      />
    </Tooltip>
  );
}
